import axios from 'axios'

export default {
  namespaced: true,
  state: {
    open: 0,
    items: [],
    item: {}
  },

  mutations: {
    setOpen (state, value) {
      state.open = value || 0
    },
    setItems (state, value) {
      state.items = value || []
    },
    setItem (state, value) {
      state.item = value || {}
    }
  },

  actions: {
    async loadItems ({ commit }) {
      try {
        let rs = await axios.get('/api/incarichi')
        // console.log('/api/incarichi', rs.data)
        commit('setItems', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadItemById ({ commit }, id) {
      try {
        let rs = await axios.get(`/api/incarichi/${id}`)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async countOpen ({ commit }) {
      try {
        let rs = await axios.get(`/api/incarichi`, { params: { op: 'contaAperte' } })
        commit('setOpen', rs.data.count)
      } catch (err) {
        throw err
      }
    },

    async addNew ({ commit }, { codiceUib, codiceUtente, codiceFiscaleIncaricato }) {
      try {
        // console.log('addNew incarico', codiceUib, codiceUtente, codiceFiscaleIncaricato)
        let rs = await axios.post(`/api/incarichi`, { codiceUib, codiceUtente, codiceFiscaleIncaricato })
        commit('setItem', rs.data)
        return rs.data
      } catch (err) {
        throw err
      }
    },

    async save ({ commit }, { id, formData }) {
      try {
        // console.log('formData.incarico', id, formData.get('incarico'))
        let rs = await axios({ method: 'put', url: `/api/incarichi/${id}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },

    async delete ({ commit }, item) {
      try {
        let rs = await axios.put(`/api/incarichi/${item.id}/delete`, item)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },

    async allegati ({ commit }, { templateId, documentData }) {
      try {
        // console.log('Parametri per la post', templateId, documentData)
        await axios.post(`/api/istanze/allegati`, { templateId, documentData }, { responseType: 'blob' }).then(function (response) {
          // console.log('Contenuto della response', response)

          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const link = document.createElement('a')
          link.href = url
          // console.log('Nome file generato..', documentData)
          link.download = templateId + '_' + documentData.id + '.pdf'
          // link.setAttribute('download', 'file.pdf') // or any other extension
          // document.body.appendChild(link)
          link.click()
        })
        // commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    }

  }
}
